import slice from 'lodash/slice';
import { useEffect, useState, RefObject } from 'react';
import { useCalculatePaginationHeight } from './useCalculatePaginationHeight';

export const usePaginateInstances = (
  instances: any[],
  containerRef: RefObject<HTMLDivElement | null>,
) => {
  const [page, setPage] = useState<number>(1);

  const { PAGE_SIZE, LIST_CONTAINER_SIZE } = useCalculatePaginationHeight(containerRef);

  const start = (page - 1) * PAGE_SIZE;
  const end = start + PAGE_SIZE;

  const instancesPage = slice(instances, start, end);

  useEffect(() => {
    setPage(1);
  }, [instances]);

  return {
    LIST_CONTAINER_SIZE,
    instancesPage,
    PAGE_SIZE,
    setPage,
    page,
  };
};
